// src/pages/Appointments/appointmentsTourConfig.js

export const appointmentsTourSteps = [
    {
        popover: {
            title: '👋 Bienvenue sur Vos Rendez-vous',
            description: 'Je vais vous guider à travers la gestion de vos rendez-vous médicaux et la recherche de médecins.',
            side: 'over',
        },
    },
    {
        element: '.appointments-main',
        popover: {
            title: '📅 Page Rendez-vous',
            description: 'Cette page vous permet de chercher des médecins, consulter vos rendez-vous à venir et votre historique de visites.',
            position: 'center',
        },
    },
    {
        element: '.appointments-row',
        popover: {
            title: '🏥 Disposition Principale',
            description: 'La page est divisée en deux sections : la recherche de médecins à gauche et vos rendez-vous à droite.',
            position: 'bottom',
        },
    },
    {
        element: '.providers-section',
        popover: {
            title: '🔍 Recherche de Médecins',
            description: 'Trouvez des médecins de confiance par spécialité, expérience ou localisation. Vous pouvez planifier des rendez-vous directement.',
            position: 'right',
        },
    },
    {
        element: '.providers-list',
        popover: {
            title: '📋 Liste des Fournisseurs',
            description: 'Liste complète des médecins disponibles. Faites défiler pour voir plus de médecins.',
            position: 'right',
        },
    },
    {
        element: '.providers-header',
        popover: {
            title: '👨‍⚕️ En-tête de Recherche',
            description: '"Connect with Trusted Providers from Anywhere" - trouvez un médecin par spécialité, expérience ou localisation.',
            position: 'bottom',
        },
    },
    {
        element: '.providers-grid',
        popover: {
            title: '🔲 Grille de Médecins',
            description: 'Chaque carte représente un médecin avec ses informations : nom, spécialité, localisation et disponibilité.',
            position: 'top',
        },
    },
    {
        element: '.doctor-card',
        popover: {
            title: '👨‍⚕️ Carte de Médecin',
            description: 'Cliquez sur la carte pour voir les détails du médecin. Chaque carte affiche : photo, nom, spécialité, localisation et prochaine disponibilité.',
            position: 'right',
        },
    },
    {
        element: '.doctor-avatar',
        popover: {
            title: '📸 Photo du Médecin',
            description: 'Photo de profil du médecin pour identification visuelle.',
            position: 'right',
        },
    },
    {
        element: '.doctor-name',
        popover: {
            title: '👤 Nom du Médecin',
            description: 'Nom complet du praticien médical.',
            position: 'right',
        },
    },
    {
        element: '.doctor-specialty',
        popover: {
            title: '🩺 Spécialité',
            description: 'La spécialité du médecin (Pédiatrie, Cardiologie, Dermatologie, etc.) pour vous aider à trouver le bon praticien.',
            position: 'right',
        },
    },
    {
        element: '.doctor-location',
        popover: {
            title: '📍 Localisation',
            description: 'Le lieu de travail du médecin. Utile pour trouver un médecin proche de vous.',
            position: 'right',
        },
    },
    {
        element: '.doctor-next-available',
        popover: {
            title: '🕐 Prochaine Disponibilité',
            description: 'La date ou le statut de la prochaine disponibilité du médecin (ex: "Soon").',
            position: 'right',
        },
    },
    {
        element: '.schedule-btn',
        popover: {
            title: '📅 Planifier un Rendez-vous',
            description: 'Cliquez sur ce bouton pour prendre rendez-vous avec le médecin sélectionné.',
            position: 'bottom',
        },
    },
    {
        element: '.appointments-sections',
        popover: {
            title: '📊 Vos Rendez-vous',
            description: 'Cette section regroupe vos rendez-vous à venir et votre historique de visites passées avec onglets.',
            position: 'left',
        },
    },
    {
        element: '.appointment-tabs-container',
        popover: {
            title: '📑 Onglets de Rendez-vous',
            description: 'Deux onglets disponibles : "Upcoming Appointments" pour vos prochains rendez-vous et "Appointment History" pour l\'historique.',
            position: 'top',
        },
    },
    {
        element: '.tab-buttons',
        popover: {
            title: '🔘 Sélecteur d\'Onglets',
            description: 'Cliquez sur l\'onglet "Upcoming Appointments" ou "Appointment History" pour basculer entre les sections.',
            position: 'bottom',
        },
    },
    {
        element: '.upcoming-appointments-container',
        popover: {
            title: '🔔 Rendez-vous À Venir',
            description: 'Vos prochains rendez-vous médicaux avec les détails complets : médecin, date, heure et options de gestion.',
            position: 'top',
        },
    },
    {
        element: '.upcoming-section-header',
        popover: {
            title: '📋 En-tête des Rendez-vous À Venir',
            description: '"Stay Prepared: Your Scheduled Health Visits" - section pour gérer vos prochains rendez-vous. Activez "Remind me" pour recevoir des notifications.',
            position: 'bottom',
        },
    },
    {
        element: '.remind-label',
        popover: {
            title: '🔔 Rappels',
            description: 'Activez cette option avec le switch pour recevoir des rappels avant vos rendez-vous.',
            position: 'left',
        },
    },
    {
        element: '.upcoming-appointments',
        popover: {
            title: '📅 Liste des Rendez-vous',
            description: 'Vos rendez-vous à venir avec détails complets et options d\'action.',
            position: 'left',
        },
    },
    {
        element: '.upcoming-card',
        popover: {
            title: '📅 Carte de Rendez-vous',
            description: 'Chaque rendez-vous affiche : photo du médecin, nom, spécialité, date/heure et boutons d\'action pour reprogrammer.',
            position: 'left',
        },
    },
    {
        element: '.provider-avatar',
        popover: {
            title: '📸 Avatar du Médecin',
            description: 'Photo du médecin pour ce rendez-vous.',
            position: 'right',
        },
    },
    {
        element: '.appointment-details',
        popover: {
            title: '📝 Détails du Rendez-vous',
            description: 'Informations complètes : nom du médecin, spécialité, date et heure du rendez-vous.',
            position: 'left',
        },
    },
    {
        element: '.provider-name',
        popover: {
            title: '👨‍⚕️ Nom du Médecin',
            description: 'Nom du praticien pour ce rendez-vous.',
            position: 'right',
        },
    },
    {
        element: '.provider-title',
        popover: {
            title: '🩺 Titre/Spécialité',
            description: 'Spécialité du médecin (ex: Cardiologist, Dermatologist).',
            position: 'right',
        },
    },
    {
        element: '.appointment-time',
        popover: {
            title: '🕐 Date et Heure',
            description: 'Date exacte et plage horaire de votre rendez-vous médical.',
            position: 'left',
        },
    },
    {
        element: '.appointment-actions',
        popover: {
            title: '⚙️ Actions',
            description: 'Boutons pour reprogrammer votre rendez-vous avec le médecin.',
            position: 'bottom',
        },
    },
    {
        element: '.reschedule-btn',
        popover: {
            title: '🔄 Reprogrammer',
            description: 'Cliquez pour modifier la date ou l\'heure de votre rendez-vous.',
            position: 'bottom',
        },
    },
    {
        popover: {
            title: '🎉 Tour Terminé !',
            description: 'Vous savez maintenant comment gérer vos rendez-vous médicaux. N\'oubliez pas d\'activer les rappels pour ne pas manquer vos visites !',
            side: 'over',
        },
    },
];